import MyWorker from './cached-image-keys-worker?worker';

export const getCachedImageKeysByWorker = async () => {
  const worker = new MyWorker();

  return new Promise<Set<string>>((resolve, reject) => {
    worker.onmessage = (e) => {
      const res = e.data;
      if (res) {
        resolve(res.value);
      } else {
        reject();
      }
      worker.terminate();
    };

    worker.onerror = () => {
      worker.terminate();
      reject('web worker发生错误');
    };

    worker.postMessage({});
  });
};
